/**
 * messageSound — toca o som curto de notificação quando uma mensagem nova chega.
 *
 * Uso:
 *   import { playMessageSound } from '@/modules/chat/utils/messageSound';
 *   playMessageSound();
 *
 * Notas:
 * - Arquivo servido estaticamente em `/assets/notifications/audio/message.mp3`
 * - O HTMLAudioElement é criado uma vez e reaproveitado (evita alocar a cada msg).
 * - `play()` retorna uma Promise que pode rejeitar se o browser bloqueou autoplay
 *   antes de qualquer interação do user; nesse caso apenas logamos e seguimos.
 * - Sempre reinicia `currentTime = 0` para garantir que mensagens em sequência
 *   toquem do início, não empilhem ou dêem skip.
 */

const SOUND_URL = '/assets/notifications/audio/message.mp3';

let cachedAudio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
  if (!cachedAudio) {
    cachedAudio = new Audio(SOUND_URL);
    cachedAudio.preload = 'auto';
  }
  return cachedAudio;
}

export function playMessageSound(): void {
  try {
    const audio = getAudio();
    audio.currentTime = 0;
    void audio.play().catch((err: unknown) => {
      // Browsers podem bloquear autoplay antes de interação; não é fatal.
      console.debug('[messageSound] play() bloqueado/falhou:', err);
    });
  } catch (err: unknown) {
    console.debug('[messageSound] falha ao tocar:', err);
  }
}
